.m-dialog__headline#pwc-dialog-headline {
	font-size: 1.5em;
}

//.m-dialog > bbg-box div.a-box {
//	--max-dialog-width: 55rem;
//}

.m-dialog__content {
	color: var(--dock-font-color, --plain__enabled__front__default);
	background-color: var(--dock-background-color, var(--background));
}

.text-bold {
	font-weight: bold;
}

#title {
	font-size: var(--dock-title-font-size, 0.9em) !important;
}

p {
	font-size: var(--dock-paragraph-font-size, 1em) !important;
}

.footer-links {
	font-size: var(--dock-footer-link-font-size, 1em) !important;
}

#back-button {
	font-size: var(--dock-back-button-font-size, 1em) !important;
	margin-bottom: 1rem;
	display: inline-block;
	width: auto;

	.a-button__label {
		margin: 0;
		padding: 0;
	}
}

.checkbox {
	div {
		label {
			span {
				font-size: var(--dock-checkbox-title-font-size, 1em) !important;
			}

			p {
				font-size: var(--dock-checkbox-description-font-size, 1em) !important;

				.checkbox-link {
					font-size: var(--dock-checkbox-link-font-size, 1em) !important;
				}
			}
		}
	}
}

.m-dialog__actions {
	margin-bottom: 1.5rem !important; //override FROK style (.m-dialog__content>*:last-child)

	.button-group {
		flex-direction: row-reverse;
		justify-content: normal; // override FROK style (flex-end) to pull "save" button to the right
	}

	bbg-button {
		button {
			align-items: center;
			min-width: 9.5em; //min-width for better looking buttons (e.g. "Save"). Also Accept and Decline have similar width (in English)
			i {
				svg {
					transform: var(--dock-button-icon-font-size, scale(1)) !important;
				}
			}
			div {
				font-size: var(--dock-button-font-size, 1em) !important;
			}
		}
	}
}

/* Style fix for button icons ---
ToDo: We should be able to (partly) remove this after FROK update (to >=3.8)	!
*/
.a-button i.a-icon {
	font-size: 1em;
	height: 3em;
	width: 2.75em;
	padding: 0.75em 0.5em 0.75em 0.75em;
	line-height: 1em;
}

.a-button.-without-icon div.a-button__label {
	padding: 0.75em 1em 0.75em 0;
}
/* End of button icon style fix */

.a-button--primary {
	background-color: var(--dock-primary-button-color, var(--bosch-blue-50)) !important;
	color: var(--dock-primary-button-text-color, white) !important;
	border-color: var(--dock-primary-button-border-color, var(--bosch-blue-50)) !important;
	border-radius: var(--dock-primary-button-border-radius, none) !important;
	border-width: var(--dock-primary-button-border-width, 1px) !important;
	border-style: var(--dock-primary-button-border-style, solid) !important;

	&:hover {
		background-color: var(--dock-primary-button-hover-color, var(--bosch-blue-40)) !important;
		color: var(--dock-primary-button-text-hover-color, white) !important;
		border-color: var(--dock-primary-button-border-hover-color, var(--bosch-blue-50)) !important;
		border-width: var(--dock-primary-button-border-hover-width, 1px) !important;
		border-radius: var(--dock-primary-button-border-hover-radius, none) !important;
		border-style: var(--dock-primary-button-border-hover-style, solid) !important;

		#accept-icon {
			path {
				fill: var(--dock-accept-icon-hover-color, white) !important;
			}
		}

		#decline-icon {
			path {
				fill: var(--dock-decline-icon-hover-color, var(--bosch-blue-40)) !important;
			}
		}

		#options-icon {
			path {
				fill: var(--dock-options-icon-hover-color, var(--bosch-blue-40)) !important;
			}
		}
	}
}

.a-button--secondary {
	background-color: var(--dock-secondary-button-color, none) !important;
	color: var(--dock-secondary-button-text-color, var(--bosch-blue-50)) !important;
	border-color: var(--dock-secondary-button-border-color, var(--bosch-blue-50)) !important;
	border-radius: var(--dock-secondary-button-border-radius, none) !important;
	border-width: var(--dock-secondary-button-border-width, 1px) !important;
	border-style: var(--dock-secondary-button-border-style, solid) !important;

	&:hover {
		background-color: var(--dock-secondary-button-hover-color, var(--bosch-blue-90)) !important;
		color: var(--dock-secondary-button-text-hover-color, var(--bosch-blue-40)) !important;
		border-color: var(--dock-secondary-button-border-hover-color, var(--bosch-blue-40)) !important;
		border-width: var(--dock-secondary-button-border-hover-width, 1px) !important;
		border-radius: var(--dock-secondary-button-border-hover-radius, none) !important;
		border-style: var(--dock-secondary-button-border-hover-style, solid) !important;

		#accept-icon {
			path {
				fill: var(--dock-accept-icon-hover-color, white) !important;
			}
		}

		#decline-icon {
			path {
				fill: var(--dock-decline-icon-hover-color, var(--bosch-blue-40)) !important;
			}
		}

		#options-icon {
			path {
				fill: var(--dock-options-icon-hover-color, var(--bosch-blue-40)) !important;
			}
		}
	}
}

.a-button--tertiary {
	background-color: var(--dock-tertiary-button-color, none) !important;
	color: var(--dock-tertiary-button-text-color, var(--bosch-blue-50)) !important;
	border-color: var(--dock-tertiary-button-border-color, #fff) !important;
	border-radius: var(--dock-tertiary-button-border-radius, none) !important;
	border-width: var(--dock-tertiary-button-border-width, 1px) !important;
	border-style: var(--dock-tertiary-button-border-style, solid) !important;

	&:hover {
		background-color: var(--dock-tertiary-button-hover-color, var(--bosch-blue-90)) !important;
		color: var(--dock-tertiary-button-text-hover-color, var(--bosch-blue-40)) !important;
		border-color: var(--dock-tertiary-button-border-hover-color, var(--bosch-blue-90)) !important;
		border-width: var(--dock-tertiary-button-border-hover-width, 1px) !important;
		border-radius: var(--dock-tertiary-button-border-hover-radius, none) !important;
		border-style: var(--dock-tertiary-button-border-hover-style, solid) !important;

		#accept-icon {
			path {
				fill: var(--dock-accept-icon-hover-color, white) !important;
			}
		}

		#decline-icon {
			path {
				fill: var(--dock-decline-icon-hover-color, var(--bosch-blue-40)) !important;
			}
		}

		#options-icon {
			path {
				fill: var(--dock-options-icon-hover-color, var(--bosch-blue-40)) !important;
			}
		}
	}
}

bbg-checkbox .a-checkbox {
	input[type="checkbox"] {
		&:checked {
			& + label::before {
				background-color: var(--dock-checkbox-color, var(--bosch-blue-50)) !important;
			}
		}

		&:hover + label::before {
			background-color: var(--dock-checkbox-hover-color, var(--bosch-blue-40)) !important;
		}
	}

	label {
		color: inherit;
		font-size: 1em;
		padding-left: 2em;
	}
}

.a-link {
	color: var(--dock-link-color, var(--bosch-blue-50)) !important;

	&:hover {
		color: var(--dock-link-hover-color, var(--bosch-blue-40)) !important;
	}

	a {
		text-decoration: underline !important;
	}
}

.a-box {
	max-width: 44em;
}

.checkboxes {
	margin-top: 2.25em;
	margin-bottom: 1em;
}

.modal-icons {
	#accept-icon {
		path {
			fill: var(--dock-accept-icon-color, white) !important;
		}
	}

	#decline-icon {
		path {
			fill: var(--dock-decline-icon-color, var(--bosch-blue-40)) !important;
		}

		&:hover {
			fill: var(--dock-decline-icon-hover-color, var(--bosch-blue-40)) !important;
		}
	}

	#options-icon {
		path {
			fill: var(--dock-options-icon-color, var(--bosch-blue-40)) !important;
		}
	}

	@-moz-document url-prefix() {
		#accept-icon {
			margin-top: 0;
		}

		#decline-icon {
			margin-top: 0;
		}

		#options-icon {
			margin-top: 0;
		}
	}
}

input[type="checkbox"] {
	// Outline for keyboard navigation
	&:focus-visible + label::before {
		outline: auto;
		outline-offset: 3px;
	}
}

.options-button {
	margin-right: auto;
}

bbg-button > button {
	width: 100%;
	margin-left: 0 !important;
}

.top-content {
	display: flex;
	justify-content: space-between;
}

bbg-language-selector {
	width: 50%;
}

.footer {
	text-align: center;
	margin-top: 2em;
}

.footer-links {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;

	span.link-holder {
		width: auto;
	}

	.link-holder {
		margin: 0.75em;
	}
}

@media (max-width: 42rem) {
	.m-dialog__content {
		padding: 1.5em 1.5em 0 !important; //override FROK style
	}
	.m-dialog__actions .button-group {
		flex-direction: column;
	}

	.options-button {
		margin-right: 0;
	}
}
